export default __webpack_public_path__ + "static/media/Witches Get Stitches.631b1e59.jpg";